import { DateTime, type DateTimeFormatOptions } from 'luxon';

/** @deprecated Use @vp/common's `formatTime` */
const formatDate = (isoDate?: string, formatOptions?: DateTimeFormatOptions) => {
  if (!isoDate) {
    return '-';
  }
  if (formatOptions) {
    return DateTime.fromISO(isoDate).toLocaleString(formatOptions);
  }
  return DateTime.fromISO(isoDate).toFormat('LLL dd, yyyy');
};

/** @deprecated Use @vp/common's `formatTime` */
const formatTime = (isoDate?: string) => {
  if (!isoDate) {
    return '-';
  }
  return DateTime.fromISO(isoDate).toFormat('t');
};

export { formatDate };
export { formatTime };
